define('home/views/AllstarCollectionView',[
    'home/views/UserCollectionView',
], function (
    UserCollectionView
) {
    'use strict';

    /**
     * Shows a list of user cards. Hides private users, since All Stars
     * aren't supposed to be private.
     *
     * Expects a Collection of User Models.
     */
    var AllstarCollectionView = UserCollectionView.extend({
        addItemView: function (item, ItemView, index) {
            if (item.get('isPrivate'))
                return;

            return UserCollectionView.prototype.addItemView.call(this, item, ItemView, index);
        },
    });

    return AllstarCollectionView;
});

